import filterCSS from 'xss';
import Options from './xssOptions';

const XSS = function name(cnt, opts) {
  const _opts = Object.assign({}, Options, opts);
  return filterCSS(cnt, _opts);
};
export default XSS;
